import { Component, OnInit } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { TranslocoService } from '@jsverse/transloco'
import { PrimeNGConfig } from 'primeng/api'
import { BehaviorSubject, Subscription, tap } from 'rxjs'
import './core/common/dayjs'
import { InternationalizationService } from './core/i18n'
import { AuthService } from './core/services'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	isLoading$ = new BehaviorSubject<boolean>(true)

	layoutMode = 'static'

	lightMenu = true

	topbarColor = 'layout-topbar-campa'

	inlineUser = false

	isRTL = false

	inputStyle = 'outlined'

	ripple = true

	routerEvent$: Subscription

	constructor(
		private primengConfig: PrimeNGConfig,
		private authService: AuthService,
		private i18nService: InternationalizationService,
		private router: Router,
		private translocoService: TranslocoService
	) {
		const ACTIVE_LANG: 'it' | 'en' = (localStorage.getItem('CAMPA_ACTIVE_LANG') as 'it' | 'en') || 'it'
		this.i18nService.setLocalization(ACTIVE_LANG)

        this.translocoService.setActiveLang(ACTIVE_LANG)
		this.translocoService
			.load(ACTIVE_LANG)
			.pipe(tap(() => this.isLoading$.next(false)))
			.subscribe()

		this.routerEvent$ = this.router.events
			.pipe(
				tap((e) => {
					if (e instanceof NavigationStart) {
						const url = e.url
						if (url.split('/')[1] !== 'sso' && !url.split('/')[1].startsWith('login')) {
							this.authService.populate()
							this.routerEvent$.unsubscribe()
						}
					}
				})
			)
			.subscribe()
	}

	ngOnInit() {
		this.primengConfig.ripple = true
	}
}
